import React, {useState} from 'react';
import {Form} from 'formik';
import moment from 'moment';
import dayjs from 'dayjs';
import classnames from 'classnames';
import FormTitle from '../FormTitle';
import FieldInput from 'common/components/FieldInput';
import ButtonsSubmitCancel from '../ButtonsSubmitCancel';
import FieldSelect from 'common/components/FieldSelect';
import FieldTextareaAutosize from 'common/components/FieldTextareaAutosize';
import UploadingFilePopUp from 'common/components/UploadingFilePopUp/UploadingFilePopUp';
import FieldDatepicker from '../../../../common/components/FieldDatepicker';
import FieldCheckbox from '../../../../common/components/FieldCheckbox';
import ModalSharedFilesList from '../../../../common/components/ModalSharedFilesList';
import MultipleTooltip from '../../../../common/components/MultipleTooltip';
import ListUploadedFilesViewDelete from '../ListUploadedFilesViewDelete';
import FieldPasteFile from '../../../../common/components/FieldPasteFile';
import MarkFileUploaded from '../../../../common/components/MarkFileUploaded';
import FieldPasteImage from '../../../../common/components/FieldPasteImage';
import config from '../../../../config/common.json';
import iconOpenInBrowser from '../../assets/open_in_browser-24px.svg';
import styles from './styles.module.scss';

const Form_6View = ({
                      values,
                      prevPagePath,
                      nextPagePath,
                      options: {
                        supervisionFileOptions,
                        exceedUsePermitOptions,
                        exceedBuildingOptions,
                        buildPermitReasonOptions,
                        form4Options,
                        completeCertOptions,
                        dangerousStructureOptions
                      },
                      fileUploaded,
                      onFileSelected,
                      fileTypeIds,
                      showUploadingFilePopUp,
                      progress,
                      stepData,
                      shumaID,
                      stepID,
                      shumaTypeID,
                      fileSelectOptions: {
                        commonHousePlan,
                        permitBlueprint,
                        plansInEffect,
                        licensingDocuments,
                        houseSharedDocuments,
                        form4,
                        completeCert,
                        dangerousStructure,
                        houseSharedOrder,
                        propertyLegalDefinition
                      },
                      filesListData,
                      setFieldValue
                    }) => {
  const [permitNumber, setPermitNumber] = useState('');
  const permitNumberValue = values.buildPermitNumber;
  const sendPermitNumber = () => setPermitNumber(permitNumberValue);
  const permitNumberDescription = permitNumber || stepData.buildPermitNumber;
  const mandatoryFieldHousePermitCondition = (
    (values.exceedUsePermit && values.exceedUsePermit.value === 1) ||
    (values.exceedBuilding && values.exceedBuilding.value === 1)
  );

  return (
    <div className={styles.form_6}>
      <FormTitle title={'המצב התכנוני'}/>
      <Form>
        <div className={classnames(styles.unit_1, styles.marginBottom25)}>
          <div className={classnames(styles.subHeaderContainer, styles.marginBottom16)}>
            <h4 className={styles.buttonsSubheader}>קובץ תשריט הדירה מהבית המשותף</h4>
            <MultipleTooltip
              id={'commonHousePlanLocatingApartmentTooltip'}
              label={'אנא ודא התאמה בין התשריט לבין תקנון וצו'}
            />
          </div>
          <FieldCheckbox fieldId={'fileType12Switch'}/>
          <div className={styles.additionalFiles}>
            {commonHousePlan.type && (
              <>
                <ModalSharedFilesList file={commonHousePlan} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
            )}
            <a
              href={config.fileExtractorLink}
              className={styles.find}
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
              <div>אתר</div>
            </a>
            <div className={styles.attachPlan}>
              {fileUploaded.commonHousePlanFileUploaded && <MarkFileUploaded/>}
              {!values.fileType12Switch
                ? (
                  <FieldPasteFile
                    fieldId="commonHousePlanFileUploaded"
                    fileUploaded={fileUploaded.commonHousePlanFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.commonHousePlanLocatingApartment)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId="commonHousePlanFileUploaded"
                    fileUploaded={fileUploaded.commonHousePlanFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.commonHousePlanLocatingApartment)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.commonHousePlanLocatingApartment}
            shumaId={shumaID}
          />
          <div className={classnames(styles.subHeaderContainer, styles.marginBottom16)}>
            <h4 className={styles.buttonsSubheader}>קובץ תקנון בית משותף</h4>
            <MultipleTooltip
              id={'houseSharedDocumentsTooltip'}
              label={'אנא ודא התאמה בין התקנון לתשריט והצו'}
            />
          </div>
          <FieldCheckbox fieldId={'fileType16Switch'}/>
          <div className={styles.additionalFiles}>
            {houseSharedDocuments.type && (
              <>
                <ModalSharedFilesList file={houseSharedDocuments} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
            )}
            <a
              href={config.fileExtractorLink}
              className={styles.find}
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
              <div>אתר</div>
            </a>
            <div className={styles.attachPlan}>
              {fileUploaded.houseSharedDocumentsFileUploaded && <MarkFileUploaded/>}
              {!values.fileType16Switch
                ? (
                  <FieldPasteFile
                    fieldId={'houseSharedDocumentsFileUploaded'}
                    fileUploaded={fileUploaded.houseSharedDocumentsFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.houseSharedDocuments)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId={'houseSharedDocumentsFileUploaded'}
                    fileUploaded={fileUploaded.houseSharedDocumentsFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.houseSharedDocuments)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.houseSharedDocuments}
            shumaId={shumaID}
          />
          <div className={classnames(styles.subHeaderContainer, styles.marginBottom16)}>
            <h4 className={styles.buttonsSubheader}>קובץ צו בית משותף</h4>
            <MultipleTooltip
              id={'houseSharedOrderTooltip'}
              label={'אנא ודא התאמה בין הצו לתשריט ולתקנון'}
            />
          </div>
          <FieldCheckbox fieldId={'fileType25Switch'}/>
          <div className={styles.additionalFiles}>
            {houseSharedOrder.type && (
              <>
                <ModalSharedFilesList file={houseSharedOrder} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
            )}
            <a
              href={config.fileExtractorLink}
              className={styles.find}
              target="_blank" rel="noreferrer"
            >
              <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
              <div>אתר</div>
            </a>
            <div className={styles.attachPlan}>
              {fileUploaded.houseSharedOrderFileUploaded && <MarkFileUploaded/>}
              {!values.fileType25Switch
                ? (
                  <FieldPasteFile
                    fieldId={'houseSharedOrderFileUploaded'}
                    fileUploaded={fileUploaded.houseSharedOrderFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.houseSharedOrder)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId={'houseSharedOrderFileUploaded'}
                    fileUploaded={fileUploaded.houseSharedOrderFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.houseSharedOrder)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.houseSharedOrder}
            shumaId={shumaID}
          />
          <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>קובץ תשריט הדירה מההיתר</h4>
          <FieldCheckbox fieldId={'fileType13Switch'}/>
          <div className={styles.additionalFiles}>
            {permitBlueprint.type && (
              <>
                <ModalSharedFilesList file={permitBlueprint} shumaID={shumaID} stepID={stepID}/>
                <div className={styles.divideLine}/>
              </>
            )}
            {Boolean(stepData.permitTasritLink) &&
              <a
                href={stepData.permitTasritLink}
                className={styles.find}
                target="_blank" rel="noreferrer"
              >
                <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
                <div>אתר</div>
              </a>}
            <div className={styles.attachPermit}>
              {fileUploaded.permitBlueprintFileUploaded && <MarkFileUploaded/>}
              {!values.fileType13Switch
                ? (
                  <FieldPasteFile
                    fieldId="permitBlueprintFileUploaded"
                    fileUploaded={fileUploaded.permitBlueprintFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.permitBlueprint)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId="permitBlueprintFileUploaded"
                    fileUploaded={fileUploaded.permitBlueprintFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.permitBlueprint)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.permitBlueprint}
            shumaId={shumaID}
          />
          <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>תוכניות בתוקף</h3>
          <div className={styles.marginBottom25}>
            <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>קובץ תוכניות בתוקף</h4>
            <FieldCheckbox fieldId={'fileType14Switch'}/>
            <div className={styles.additionalFiles}>
              {plansInEffect.type && (
                <>
                  <ModalSharedFilesList file={plansInEffect} shumaID={shumaID} stepID={stepID}/>
                  <div className={styles.divideLine}/>
                </>
              )}
              {Boolean(stepData.validPlansLink) &&
                <a
                  href={stepData.validPlansLink}
                  className={styles.find}
                  target="_blank" rel="noreferrer"
                >
                  <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
                  <span>אתר</span>
                </a>
              }
              <div className={styles.attachPlan}>
                {fileUploaded.plansInEffectFileUploaded && <MarkFileUploaded/>}
                {!values.fileType14Switch
                  ? (
                    <FieldPasteFile
                      fieldId="plansInEffectFileUploaded"
                      fileUploaded={fileUploaded.plansInEffectFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.plansInEffect)}
                      setFieldValue={setFieldValue}
                    />
                  )
                  : (
                    <FieldPasteImage
                      fieldId="plansInEffectFileUploaded"
                      fileUploaded={fileUploaded.plansInEffectFileUploaded}
                      onFileSelected={onFileSelected(fileTypeIds.plansInEffect)}
                      setFieldValue={setFieldValue}
                      formFields={'onlyFreeText'}
                    />
                  )
                }
              </div>
            </div>
            <ListUploadedFilesViewDelete
              data={filesListData}
              fileTypeID={fileTypeIds.plansInEffect}
              shumaId={shumaID}
            />
          </div>
          {(shumaTypeID !== 3 && shumaTypeID !== 4) &&
            <FieldDatepicker
              fieldId="plansCheckDate"
              label={'תאריך בדיקת תוכניות'}
              containerStyles={classnames(styles.halfField, styles.marginBottom25)}
            />
          }
          <FieldTextareaAutosize
            fieldId="validLocalPlansDetails"
            value={values.validLocalPlansDetails}
            label="פירוט תכניות מקומיות בתוקף"
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldTextareaAutosize
            fieldId="countryStateData"
            value={values.countryStateData}
            label="מחוזיות/ארציות"
          />
        </div>
        <div className={classnames(styles.unit_2, styles.marginBottom25)}>
          <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>בהליכי תכנון/הפקדה</h3>
          <FieldTextareaAutosize
            fieldId="plansInProgress"
            value={values.plansInProgress}
            label="תכניות בהליכים"
            containerCustomStyles={styles.marginBottom25}
          />
          {(shumaTypeID !== 3 && shumaTypeID !== 4) &&
            <>
              <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}> קובץ מסמכי רישוי</h4>
              <FieldCheckbox fieldId={'fileType15Switch'}/>
              <div className={styles.specRow}>
                {licensingDocuments.type && (
                  <>
                    <ModalSharedFilesList file={licensingDocuments} shumaID={shumaID} stepID={stepID}/>
                    <div className={styles.divideLine}/>
                  </>
                )}
                {stepData.permitDocumentsLink &&
                  <a
                    href={stepData.permitDocumentsLink}
                    className={styles.findDocument}
                    target="_blank" rel="noreferrer"
                  >
                    <img src={iconOpenInBrowser} className={styles.iconOpenInBrowser} alt="i"/>
                    <span>אתר</span>
                  </a>
                }
                <div className={styles.uploadDocument}>
                  {fileUploaded.licensingDocumentsFileUploaded && <MarkFileUploaded/>}
                  {!values.fileType15Switch
                    ? (
                      <FieldPasteFile
                        fieldId={'licensingDocumentsFileUploaded'}
                        fileUploaded={fileUploaded.licensingDocumentsFileUploaded}
                        onFileSelected={onFileSelected(fileTypeIds.licensingDocuments)}
                        setFieldValue={setFieldValue}
                      />
                    )
                    : (
                      <FieldPasteImage
                        fieldId={'licensingDocumentsFileUploaded'}
                        fileUploaded={fileUploaded.licensingDocumentsFileUploaded}
                        onFileSelected={onFileSelected(fileTypeIds.licensingDocuments)}
                        setFieldValue={setFieldValue}
                        formFields={'onlyFreeText'}
                      />
                    )
                  }
                </div>
              </div>
              <ListUploadedFilesViewDelete
                data={filesListData}
                fileTypeID={fileTypeIds.licensingDocuments}
                shumaId={shumaID}
              />
            </>
          }
        </div>
        <div className={classnames(styles.unit_3, styles.marginBottom25)}>
          <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>פירוט
            רישוי בניה עפ"י מידע מתיק הבניין<span>(2)  (1)</span>
          </h3>
          <h5 className={classnames(styles.subHeaderSmaller, styles.marginBottom25)}> היתר בניה ראשוני</h5>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldInput
              fieldId="buildPermitNumber"
              value={values.buildPermitNumber}
              onBlur={sendPermitNumber}
              label={'מספר היתר בניה'}
              containerCustomStyles={styles.halfField}
            />
            <FieldDatepicker
              fieldId="buildPermitDate"
              minDate={dayjs('1950-01-01')}
              label={'תאריך היתר בניה'}
              containerStyles={styles.halfField}
            />
          </div>
          <FieldSelect
            fieldId="buildPermitReason"
            label={'מהות היתר'}
            options={buildPermitReasonOptions}
            containerStyles={classnames(styles.quarterField, styles.marginBottom25)}
          />
          <FieldTextareaAutosize
            fieldId="buildPermitDetails"
            value={values.buildPermitDetails}
            label={'פירוט היתר'}
            containerCustomStyles={styles.marginBottom25}
          />
          <FieldCheckbox
            fieldId="buildPermitNotSigned"
            label="תכנית לא חתומה"
            containerStyles={classnames(styles.quarterField, styles.w200, styles.marginBottom25)}
          />
          {values.buildPermitNotSigned &&
            <FieldTextareaAutosize
              fieldId="buildPermitNotSignedText"
              value={values.buildPermitNotSignedText}
              mandatoryMark={true}
              label={'פירוט לתוכנית לא חתומה'}
              containerCustomStyles={styles.marginBottom25}
            />
          }
          <FieldTextareaAutosize
            fieldId="additionalBuildPermitText"
            value={values.additionalBuildPermitText}
            label={
              <div className={styles.flex}>
                <span className={styles.marginLeft}>היתרים נוספים</span>
                <MultipleTooltip
                  id={'additionalBuildPermitTextTooltip'}
                  label={'מספר היתר, תאריך ההיתר, מהות היתר, פירוט היתר'}
                />
              </div>
            }
            containerCustomStyles={styles.marginBottom25}
          />
          <div className={classnames(
            styles.flexBetween,
            styles.threeQuartersField,
            styles.marginBottom25
          )}>
            <FieldSelect
              fieldId="form4"
              label={'טופס 4'}
              options={form4Options}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="completeCert"
              label={'תעודת גמר'}
              options={completeCertOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="dangerousStructure"
              label={'מבנה מסוכן'}
              options={dangerousStructureOptions}
              containerStyles={styles.quarterField}
            />
          </div>
          {(values.form4 && values.form4.value === 1) &&
            <>
              <div className={styles.marginBottom25}>
                <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>קובץ עבור טופס 4</h4>
                <FieldCheckbox fieldId={'fileType22Switch'}/>
                <div
                  className={classnames(styles.additionalFiles, styles.marginBottom25)}>
                  {form4.type && (
                    <>
                      <ModalSharedFilesList file={form4} shumaID={shumaID} stepID={stepID}/>
                      <div className={styles.divideLine}/>
                    </>
                  )}
                  <div className={styles.attachPermit}>
                    {fileUploaded.form4FileUploaded && <MarkFileUploaded/>}
                    {!values.fileType22Switch
                      ? (
                        <FieldPasteFile
                          fieldId={'form4FileUploaded'}
                          fileUploaded={fileUploaded.form4FileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.form4)}
                          setFieldValue={setFieldValue}
                        />
                      )
                      : (
                        <FieldPasteImage
                          fieldId={'form4FileUploaded'}
                          fileUploaded={fileUploaded.form4FileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.form4)}
                          setFieldValue={setFieldValue}
                          formFields={'onlyFreeText'}
                        />
                      )
                    }
                  </div>
                </div>
                <ListUploadedFilesViewDelete
                  data={filesListData}
                  fileTypeID={fileTypeIds.form4}
                  shumaId={shumaID}
                />
              </div>
              <div className={styles.marginBottom25}>
                <FieldTextareaAutosize
                  fieldId={'form4Text'}
                  value={values.form4Text}
                  label={
                    <div className={styles.flex}>
                      <span className={styles.marginLeft}>פירוט טופס 4</span>
                      <MultipleTooltip
                        id={'formTooltip'}
                        label={'לדוגמא: טופס 4 ניתן ביום 09.05.2010 לבניין שנבנה בגוש 2852 חלקה 171 מגרש 1022 לפי היתר בניה מס\' 20248075'}
                      />
                    </div>
                  }
                />
              </div>
            </>
          }
          {(values.completeCert && values.completeCert.value === 1) &&
            <>
              <div className={styles.marginBottom25}>
                <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>קובץ עבור תעודת גמר</h4>
                <FieldCheckbox fieldId={'fileType23Switch'} />
                <div
                  className={classnames(styles.additionalFiles, styles.marginBottom25)}>
                  {completeCert.type && (
                    <>
                      <ModalSharedFilesList file={completeCert} shumaID={shumaID} stepID={stepID}/>
                      <div className={styles.divideLine}/>
                    </>
                  )}
                  <div className={styles.attachPermit}>
                    {fileUploaded.completeCertFileUploaded && <MarkFileUploaded/>}
                    {!values.fileType23Switch
                      ? (
                        <FieldPasteFile
                          fieldId={'completeCertFileUploaded'}
                          fileUploaded={fileUploaded.completeCertFileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.completeCert)}
                          setFieldValue={setFieldValue}
                        />
                      )
                      : (
                        <FieldPasteImage
                          fieldId={'completeCertFileUploaded'}
                          fileUploaded={fileUploaded.completeCertFileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.completeCert)}
                          setFieldValue={setFieldValue}
                          formFields={'onlyFreeText'}
                        />
                      )
                    }
                  </div>
                </div>
                <ListUploadedFilesViewDelete
                  data={filesListData}
                  fileTypeID={fileTypeIds.completeCert}
                  shumaId={shumaID}
                />
              </div>
              <div className={styles.marginBottom25}>
                <FieldTextareaAutosize
                  fieldId={'completeCertText'}
                  value={values.completeCertText}
                  label={'פירוט תעודת גמר'}
                />
              </div>
            </>
          }
          {(values.dangerousStructure && values.dangerousStructure.value === 1) &&
            <>
              <div className={styles.marginBottom25}>
                <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>קובץ עבור מבנה מסוכן</h4>
                <FieldCheckbox fieldId={'fileType24Switch'}/>
                <div
                  className={classnames(styles.additionalFiles, styles.marginBottom25)}>
                  {dangerousStructure.type && (
                    <>
                      <ModalSharedFilesList file={dangerousStructure} shumaID={shumaID} stepID={stepID}/>
                      <div className={styles.divideLine}/>
                    </>
                  )}
                  <div className={styles.attachPermit}>
                    {fileUploaded.dangerousStructureFileUploaded && <MarkFileUploaded/>}
                    {!values.fileType24Switch
                      ? (
                        <FieldPasteFile
                          fieldId={'dangerousStructureFileUploaded'}
                          fileUploaded={fileUploaded.dangerousStructureFileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.dangerousStructure)}
                          setFieldValue={setFieldValue}
                        />
                      )
                      : (
                        <FieldPasteImage
                          fieldId={'dangerousStructureFileUploaded'}
                          fileUploaded={fileUploaded.dangerousStructureFileUploaded}
                          onFileSelected={onFileSelected(fileTypeIds.dangerousStructure)}
                          setFieldValue={setFieldValue}
                          formFields={'onlyFreeText'}
                        />
                      )
                    }
                  </div>
                </div>
                <ListUploadedFilesViewDelete
                  data={filesListData}
                  fileTypeID={fileTypeIds.dangerousStructure}
                  shumaId={shumaID}
                />
              </div>
              <div className={styles.marginBottom25}>
                <FieldTextareaAutosize
                  fieldId={'dangerousStructureText'}
                  value={values.dangerousStructureText}
                  label={'פירוט מבנה מסוכן'}
                />
              </div>
            </>
          }
        </div>
        <div className={classnames(styles.unit_4, styles.marginBottom25)}>
          <h3 className={classnames(styles.subHeader, styles.marginBottom25)}>מידע תכנוני אחר</h3>
          <div className={classnames(
            styles.threeQuartersField,
            styles.flexBetween,
            styles.marginBottom25
          )}>
            <FieldSelect
              fieldId="supervisionFile"
              label={'תיק פיקוח'}
              options={supervisionFileOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="exceedUsePermit"
              label={'היתר לשימוש חורג'}
              options={exceedUsePermitOptions}
              containerStyles={styles.quarterField}
            />
            <FieldSelect
              fieldId="exceedBuilding"
              label={'חריגות בניה'}
              options={exceedBuildingOptions}
              containerStyles={styles.quarterField}
            />
          </div>
          <FieldTextareaAutosize
            fieldId="housePermitMismatchText"
            value={values.housePermitMismatchText}
            label={(
              <div className={styles.flex}>
                {mandatoryFieldHousePermitCondition && <span className={styles.mandatoryMark}>*</span>}
                <span className={styles.marginLeft}>הערות כלליות</span>
                <MultipleTooltip
                  id={'housePermitMismatchTextTooltip'}
                  label={'עבור אי התאמה להיתר יש לציין: היקף, מיקום ומהות'}
                />
              </div>
            )}
            containerCustomStyles={styles.marginBottom25}
          />
        </div>
        <div className={styles.unit_5}>
          <h4 className={classnames(styles.buttonsSubheader, styles.marginBottom16)}>זיהוי הנכס לפי תשריט</h4>
          <FieldCheckbox fieldId={'fileType32Switch'}/>
          <div className={classnames(styles.additionalFiles, styles.marginBottom25)}>
            <ModalSharedFilesList file={propertyLegalDefinition} shumaID={shumaID} stepID={stepID}/>
            <div className={styles.divideLine}/>
            <div className={styles.attachPermit}>
              {fileUploaded.propertyLegalDefinitionFileUploaded && <MarkFileUploaded/>}
              {!values.fileType32Switch
                ? (
                  <FieldPasteFile
                    fieldId="propertyLegalDefinitionFileUploaded"
                    fileUploaded={fileUploaded.propertyLegalDefinitionFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.propertyLegalDefinition)}
                    setFieldValue={setFieldValue}
                  />
                )
                : (
                  <FieldPasteImage
                    fieldId="propertyLegalDefinitionFileUploaded"
                    fileUploaded={fileUploaded.propertyLegalDefinitionFileUploaded}
                    onFileSelected={onFileSelected(fileTypeIds.propertyLegalDefinition)}
                    setFieldValue={setFieldValue}
                    formFields={'onlyFreeText'}
                  />
                )
              }
            </div>
          </div>
          <ListUploadedFilesViewDelete
            data={filesListData}
            fileTypeID={fileTypeIds.propertyLegalDefinition}
            shumaId={shumaID}
          />
        </div>
        <div className={styles.refs}>
          <div className={styles.ref}>
            *הרקע התכנוני מובא כמידע אינפורמטיבי מאומת כבסיס לחוות הדעת. לצורך
            קבלת מידע תכנוני מוסמך,לרבות מידע לצרכי
            תכנון,יש לפנות לועדה המקומית לתכנון ובניה ולקבל זאת בכתב נכון למועד
            הפקת המידע ובהתאם למדיניות הועדה
            המקומית.
          </div>
          <div className={styles.ref}><span>(1)</span> חוות דעת זו אינה תחליף
            לחוו"ד אדריכלית. בחו"ד זו
            לא נבדקו גובה המבנה, קווי
            בניין והעמדה, המצויים בתחום המומחיות של מודד מוסמך.
          </div>
          <div className={styles.ref}><span>(2)</span>עפ"י מדידה גרפית ע"ג
            תכנית חתומה להיתר בניה מס'
            {(permitNumberDescription) ? (` ${permitNumberDescription}`) : (` ______`)} מתאריך
            {values.buildPermitDate ? (` ${moment(values.buildPermitDate).format('DD.MM.YYYY')}`) : (` __.__.____`)}
          </div>
        </div>
        <ButtonsSubmitCancel prevPagePath={prevPagePath} nextPagePath={nextPagePath}/>
      </Form>
      <UploadingFilePopUp
        showUploadingFilePopUp={showUploadingFilePopUp}
        progress={progress}
        message="הקובץ נטען, אנא המתינו"
      />
    </div>
  );
};

export default Form_6View;